<template>
  <div class="edit-container">
    <a-form-model
      class="station-form"
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }"
    >
      <a-form-model-item label="id" v-show="false" prop="id">
        <a-input v-model="form.id"> </a-input>
      </a-form-model-item>
      <a-form-model-item label="名称" prop="name">
        <a-input v-model="form.name"></a-input>
      </a-form-model-item>
      <a-form-model-item label="设备号" prop="sn">
        <a-input v-model="form.sn"></a-input>
      </a-form-model-item>
      <a-form-model-item label="经度" prop="lng">
        <a-input v-model="form.lng"></a-input>
      </a-form-model-item>
      <a-form-model-item label="纬度" prop="lat">
        <a-input v-model="form.lat"></a-input>
      </a-form-model-item>
      <a-form-model-item label="河道" prop="river">
        <a-input v-model="form.river"></a-input>
      </a-form-model-item>
      <div style="text-align: right;">
        <a-button type="primary" @click="handleOk">确定</a-button>
      </div>
    </a-form-model>
    <div id="map" class="station-map"></div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { updateStationInfoById } from "@/api/api";
import { isCheckNumber } from "@/utils/utils";
export default {
  data() {
    return {
      form: {
        id: "",
        name: "",
        sn: "",
        lng: 117.12524949,
        lat: 36.665817919,
        river: ""
      },
      rules: {
        id: { required: true, message: "请输入id" },
        name: { required: true, message: "请输入站点名称", trigger: "change" },
        sn: { required: true, message: "请输入设备号", trigger: "change" },
        lng: { required: true, message: "请选择经度", trigger: "change" },
        lat: { required: true, message: "请选择纬度", trigger: "change" },
        river: { required: true, message: "请输入河道", trigger: "change" }
      },
      map: null,
      marker: null
    };
  },
  computed: {
    ...mapState(["stationList"])
  },
  watch: {
    $route() {
      this.getItem();
    },
    "form.lng"() {
      if (!isCheckNumber(this.form.lng)) {
        return;
      }
      let point = new BMap.Point(this.form.lng, this.form.lat);
      this.map.panTo(point);
      this.marker.setPosition(point);
    },
    "form.lat"() {
      if (!isCheckNumber(this.form.lat)) {
        return;
      }
      let point = new BMap.Point(this.form.lng, this.form.lat);
      this.map.panTo(point);
      this.marker.setPosition(point);
    }
  },
  async mounted() {
    this.initMap();
    await this.getStationList();
    this.getItem();
  },
  methods: {
    ...mapActions(["getStationList"]),
    initMap() {
      let map = new BMap.Map("map", { enableMapClick: true });
      // 初始化地图,设置中心点坐标和地图级别
      let zoom = 15;
      let centerPoint = new BMap.Point(this.form.lng, this.form.lat);

      map.centerAndZoom(centerPoint, zoom);
      //开启鼠标滚轮缩放
      map.enableScrollWheelZoom(true);
      map.addControl(
        // BMAP_NORMAL_MAP, BMAP_SATELLITE_MAP, BMAP_HYBRID_MAP
        new BMap.MapTypeControl({
          mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP],
          anchor: BMAP_ANCHOR_BOTTOM_RIGHT
        })
      );
      var marker = new BMap.Marker(centerPoint, {
        enableDragging: true
      });
      map.addOverlay(marker);
      marker.addEventListener("dragend", e => {
        // this.form.lng = e.point.lng.toFixed(7);
        // this.form.lat = e.point.lat.toFixed(7);
        this.form.lng = e.point.lng;
        this.form.lat = e.point.lat;
      });
      this.map = map;
      this.marker = marker;
    },
    getItem() {
      const item =
        this.stationList.find(x => x.station_id == this.$route.params.id) || {};
      if (!this.$_.isEmpty(item)) {
        this.form.id = item.station_id;
        this.form.name = item.station_name;
        this.form.sn = item.sn;
        this.form.lng = item.lng;
        this.form.lat = item.lat;
        this.form.river = item.river;
      }
    },
    handleOk() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$confirm({
            title: "确认修改?",
            okText: "确认",
            cancelText: "取消",
            onOk: async () => {
              let params = {
                id: this.form.id,
                name: this.form.name,
                sn: this.form.sn,
                lng: this.form.lng,
                lat: this.form.lat,
                river: this.form.river
              };
              try {
                let res = await updateStationInfoById(params);
                this.$message.success(res.data.msg);
                await this.$store.dispatch("getStationList");
              } catch (error) {
                console.log(error);
              }
            },
            onCancel: () => {
              this.$message.warning("取消修改");
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.edit-container {
  display: flex;
  padding-left: 10px;
}
.station-form {
  width: 320px;
  padding-right: 10px;
}
.station-map {
  flex: 1;
  height: 100%;
}
</style>
